import React from "react";
import EOpticAndCameraFeature from "../../../Model/EOpticAndCameraFeature";
import MtiButton from "../../Buttons/MtiButton";

type Props = {
  disabled: boolean;
  onAutoExposure: (id: string) => void;
};

export default function AutoExposureControl({ disabled, onAutoExposure }: Props) {
  return (
    <div style={{ display: "flex", alignItems: "center", marginTop: 10, paddingLeft: 9 }}>
      <div style={{ fontSize: "14px", fontWeight: 700, color: "#000000", marginRight: 18 }}>Illumination Settings:</div>
      <MtiButton disabled={disabled} onClick={() => onAutoExposure(EOpticAndCameraFeature.Exposure)} size="medium">
        AUTO
      </MtiButton>
    </div>
  );
}
